"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountReactComponent = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
var react_1 = __importDefault(require("react"));
var PromptContext_1 = require("Prompt/PromptContext");
var DIProvider_1 = require("DIProvider/DIProvider");
var styles = __importStar(require("./MountReactComponent.css"));
var mountReactComponent = function (createUi, di) {
    return function (component, options) {
        return createUi(require("./MountReactComponent.html"), {
            className: styles.reactUi,
            $init: options && options.$init,
            $onElementRendered: function (elem) {
                var componentWithDIProvider = react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di }, component);
                if (di && di.has("promptOrchestrator")) {
                    var promptOrchestrator = di.get("promptOrchestrator");
                    react_dom_1.default.render(react_1.default.createElement(PromptContext_1.PromptProvider, { value: { promptOrchestrator: promptOrchestrator } }, componentWithDIProvider), elem[0]);
                }
                else {
                    react_dom_1.default.render(componentWithDIProvider, elem[0]);
                }
                elem.on("$destroy", function () {
                    react_dom_1.default.unmountComponentAtNode(elem[0]);
                    if (options && options.onDestroy) {
                        options.onDestroy();
                    }
                });
            },
        });
    };
};
exports.mountReactComponent = mountReactComponent;
exports.default = exports.mountReactComponent;
